<div
  class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full min-w-0 p-20"
>
  <!-- Summary -->
  <div
    class="flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden h-50"
  >
    <div class="flex flex-col items-center mt-2">
      <div
        class="text-7xl sm:text-8xl font-bold tracking-tight leading-none text-blue-500"
      >
        123
      </div>
      <div class="text-lg font-medium text-blue-600 dark:text-blue-500">
        All Partners
      </div>
    </div>
  </div>
  <!-- Overdue -->
  <div
    class="flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden h-50"
  >
    <div class="flex flex-col items-center mt-2">
      <div
        class="text-7xl sm:text-8xl font-bold tracking-tight leading-none text-violet-500"
      >
        17
      </div>
      <div class="text-lg font-medium text-violet-600 dark:text-violet-500">
        Trial Partners
      </div>
    </div>
  </div>
  <!-- Issues -->
  <div
    class="flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden h-50"
  >
    <div class="flex flex-col items-center mt-2">
      <div
        class="text-7xl sm:text-8xl font-bold tracking-tight leading-none text-amber-500"
      >
        24
      </div>
      <div class="text-lg font-medium text-amber-600 dark:text-amber-500">
        Plan 100 Partners
      </div>
    </div>
  </div>
  <!-- Features -->
  <div
    class="flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden h-50"
  >
    <div class="flex flex-col items-center mt-2">
      <div
        class="text-7xl sm:text-8xl font-bold tracking-tight leading-none text-green-500"
      >
        38
      </div>
      <div class="text-lg font-medium text-green-600 dark:text-green-500">
        Paid Partners
      </div>
    </div>
  </div>
  <div
    class="flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden h-50"
  >
    <div class="flex flex-col items-center mt-2">
      <div
        class="text-7xl sm:text-8xl font-bold tracking-tight leading-none text-pink-500"
      >
        20
      </div>
      <div class="text-lg font-medium text-pink-600 dark:text-pink-500">
        Suspended Partners
      </div>
    </div>
  </div>
  <div
    class="flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden h-50"
  >
    <div class="flex flex-col items-center mt-2">
      <div
        class="text-7xl sm:text-8xl font-bold tracking-tight leading-none text-red-500"
      >
        22
      </div>
      <div class="text-lg font-medium text-red-600 dark:text-red-500">
        Cancelled Partners
      </div>
    </div>
  </div>
  <div
    class="flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden h-50"
  >
    <div class="flex flex-col items-center mt-2">
      <div
        class="text-7xl sm:text-8xl font-bold tracking-tight leading-none text-white-500"
      >
        2
      </div>
      <div class="text-lg font-medium text-white-600 dark:text-white-500">
        Today's Partners
      </div>
    </div>
  </div>
</div>
